import useDispensary from 'dispensary/hooks/use-dispensary';
import useDispensaryFlag from 'shared/hooks/use-dispensary-flag';

type UseHidePotenciesReturn = {
  menuHidePotencies: boolean;
  menuHideStrains: boolean;
};

export function useHidePotenciesAndStrains(): UseHidePotenciesReturn {
  const { dispensary } = useDispensary();
  const menuHidePotencies = useDispensaryFlag(`menu.hide-potencies`, dispensary?.id);
  const menuHideStrains = useDispensaryFlag(`menu.hide-strains`, dispensary?.id);
  return { menuHidePotencies, menuHideStrains };
}
